import { render } from "./SearchApp.vue?vue&type=template&id=4fb90a9c"
import script from "./SearchApp.vue?vue&type=script&lang=js"
export * from "./SearchApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__